import React from 'react';
import PropTypes from 'prop-types';

import { useFormatMessage } from '../../intl/intlHooks'

import { addressMessages } from './messages';
import { AddressButton } from './AddressButton';

export const AddressSelect = ({ addresses, selectedHashKey, clickHandler }) => {
    const formatMessage = useFormatMessage();
    return (
        <div
            role="listbox"
            className="address-select"
            aria-label={formatMessage(addressMessages.savedAddressesLabel)}
        >
            {addresses.map(address => (
                <div key={address.hashKey} role="option" aria-selected={selectedHashKey === address.hashKey}>
                    <AddressButton
                        address={address}
                        isSelected={selectedHashKey === address.hashKey}
                        clickHandler={clickHandler}
                    />
                </div>
            ))}
        </div>
    );
};

AddressSelect.defaultProps = {
    clickHandler: () => {},
    selectedHashKey: ''
};

AddressSelect.propTypes = {
    selectedHashKey: PropTypes.string,
    clickHandler: PropTypes.func,
    addresses: PropTypes.array.isRequired
};
